// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const HeaderUtilitySwitchWholesaler: React.FC<{
    width?: number;
    height?: number;
    color1?: string;
    className?: string;
}> = ({ width = undefined, height = undefined, color1 = "#fff", className }) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 15 13" width={width} height={height}>
            <path
                fill="currentColor"
                d="M7.645 1.349a.37.37 0 0 0-.29 0L1.209 3.95a.75.75 0 0 0-.459.695v7.543a.377.377 0 0 1-.375.377.377.377 0 0 1-.375-.377V4.645c0-.608.36-1.155.919-1.39L7.064.653c.279-.117.593-.117.874 0l6.143 2.602c.556.235.919.782.919 1.39v7.543a.377.377 0 0 1-.375.377.377.377 0 0 1-.375-.377V4.645a.75.75 0 0 0-.46-.695zM2.25 5.779c0-.418.335-.755.75-.755h9c.415 0 .75.337.75.755v6.409a.377.377 0 0 1-.375.377h-9.75a.377.377 0 0 1-.375-.377zM3 11.81h9v-1.508H3zm9-3.77H3v1.508h9zm-9-.754h9V5.779H3z"
            />
        </svg>
    );
};

export default React.memo(HeaderUtilitySwitchWholesaler);
